module.exports = __webpack_public_path__ + "img/A1 (5).98a02adf.jpg";